import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import axios from '../../api/axios';


// Helper function to safely format numbers
const safeNumberFormat = (value) => {
  const number = Number(value);
  return isNaN(number) ? '0.00' : number.toFixed(2);
};

const BillTemplate = ({
  items = [],
  totals = {},
  customerName = '',
  customerPhone = '',
  customergstNo = '',
  ordernumber = '',
  billNo = Math.floor(Math.random() * 1000000)
}) => {
  // Ensure totals object has all required properties with default values
  const safeTotals = {
    subtotal: 0,
    cgst: 0,
    sgst: 0,
    discountAmount: 0,
    discountedTotal: 0,
    ...totals
  };

  const [billingNotes, setBillingNotes] = useState([""]);

  const storedData = JSON.parse(sessionStorage.getItem("userData"));




  if (storedData.business_type == 'G') {
    const businessid = sessionStorage.getItem('configBizEntityId')
    var retailShopId = businessid;
  } else {

    var retailShopId = storedData.businessEntityId;

    sessionStorage.setItem("configBizEntityId", retailShopId);
  }

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`retail/configuration/${retailShopId}`);
        if (response.status === 200) {
          const config = response.data;

          setBillingNotes(config.billing_notes ? JSON.parse(config.billing_notes) : [""]);
        }
      } catch (error) {
        console.error("Error fetching configuration:", error);
      }
    };

    fetchConfig();
  }, [retailShopId]);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchRetailBusinesses = async () => {
      try {
        const response = await axios.get(
          `retail/getRetailBusinesses?businessEntityId=${retailShopId}`
        );
        setData(response.data);

      } catch (err) {
        console.error("error fetching data")

      }
    };

    if (retailShopId) {
      fetchRetailBusinesses();
    }
  }, [retailShopId]);

  console.log("itemsssssdd", safeTotals)
  return (
    <div id="bill-print" className="w-full max-w-[300px] p-4 text-sm" style={{ marginTop: "30px" }}>
      {/* Header */}
      <div className="text-center mb-4">
        {data.map((business) => (
          <div key={business.business_entity_id}>
            <h2 className="font-bold text-lg capitalize">
              {business.business_name}
            </h2>
            <p>{business.address}</p>
            <p>Phone:{business.contact_no}</p>
            {business.gst_no && (
              <p>GSTIN:{business.gst_no}</p>
            )}
          </div>
        ))}
      </div>



      {/* Bill Details */}
      <div className="border-t border-b py-2 mb-4">
        <div className="flex justify-between">
          {/* <span>Bill No: {billNo}</span> */}
          <span>Bill No: {ordernumber}</span>
        </div>
        <div className="flex justify-between">
          <span>Date:{new Date().toLocaleDateString()}</span>
        </div>
        <div className="flex justify-between">
          <span>Time: {new Date().toLocaleTimeString()}</span>
        </div>
        {customerName && (
          <div>Customer: {customerName}</div>
        )}
        {customerPhone && (
          <div>Phone: {customerPhone}</div>
        )}
        {customergstNo && (
          <div>GST No: {customergstNo}</div>
        )}
      </div>

      {/* Items */}
      <table className="w-full mb-4">
        <thead>
          <tr className="border-b">
            <th className="text-left">Item</th>
            <th className="text-right">Qty</th>
            <th className="text-right">Price</th>
            {/* <th className="text-right">Taxable amount</th> */}
            <th className="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td className="text-left">{item.item_name}</td>
              <td className="text-right">{item.quantity}</td>
              <td className="text-right">₹{safeNumberFormat(item.item_price)}</td>
              {/* <td className="text-right">{item.item_taxableamount}</td> */}
              <td className="text-right">₹{safeNumberFormat(item.item_price * item.quantity)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div className="border-t pt-1">
        <table className="w-full text-xs">
          <tbody>
            {safeTotals.itemDiscounts > 0 && (
              <tr>
                <td className="text-left">Total MRP:</td>
                <td className="text-right font-bold">₹{safeNumberFormat(items.reduce((sum, item) => sum + item.item_price * item.quantity, 0))}</td>
              </tr>
            )}
            {safeTotals.itemDiscounts > 0 && (
              <tr className="">
                <td className="text-left">Item Discount:</td>
                <td className="text-right font-bold">₹{safeNumberFormat(safeTotals.itemDiscounts)}</td>
              </tr>
            )}
            <tr>
              <td className="text-left">Sub Total:</td>
              <td className="text-right font-bold">₹{safeNumberFormat(safeTotals.subtotal)}</td>
            </tr>
            {safeTotals.globalDiscountAmount > 0 && (
              <tr>
                <td className="text-left">Bill Discount:</td>
                <td className="text-right font-bold">₹{safeNumberFormat(safeTotals.globalDiscountAmount)}</td>
              </tr>
            )}
            {/* <tr>
              <td className="text-left">Taxable Amount:</td>
              <td className="text-right font-bold">₹{safeNumberFormat(safeTotals.taxableAmount)}</td>
            </tr> */}
            <tr className="border-t w-full">
              <td className="text-left font-bold text-md">Grand Total:</td>
              <td className="text-right font-bold text-md">₹{safeNumberFormat(safeTotals.grandTotal)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table className="w-full mb-4 border-t pt-1" style={{ marginTop: "20px" }}>
        <thead>
          <tr className="border-b">
            <th className="text-left">Taxable Amount</th>
            <th className="text-right">CGST</th>
            <th className="text-right">SGST</th>
            {/* <th className="text-right">Taxable amount</th> */}
            <th className="text-right">Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {/* {items.map((item, index) => ( */}
          <tr >
            <td className="text-left">₹{safeNumberFormat(safeTotals.taxableAmount)}</td>
            <td className="text-right">₹{safeNumberFormat(safeTotals.
              totalcgst)}</td>
            <td className="text-right">₹{safeNumberFormat(safeTotals.
              totalsgst)}</td>
            {/* <td className="text-right">{item.item_taxableamount}</td> */}
            <td className="text-right">₹{safeNumberFormat(safeTotals.grandTotal)}</td>
          </tr>

        </tbody>
      </table>





      {billingNotes.length > 0 && (
        <div className="mt-2">
          {billingNotes.map((note) => (
            <div key={note.id} >{note}</div>
          ))}

        </div>
      )}

      {/* Footer */}
      <div className="text-center mt-4 text-xs">
        <p>Thank you for choosing us. Visit us again!</p>
        <p>Powered By BuyByeQ</p>
      </div>
    </div>
  );
};

// Function to handle printing
const printBill = (customerInfos = {}, items = [], totals = {}, paymentInfo = {}) => {
  // Create a new window for printing
  console.log("lll", customerInfos)
  const printWindow = window.open('', '', 'width=600,height=600');

  if (!printWindow) {
    alert("Please allow popups for this website to print bills.");
    return;
  }

  // Set up the print window document
  printWindow.document.write('<html><head><title>Print Bill</title>');

  // Add CSS
  printWindow.document.write(`
    <style>
      /* Reset CSS */
      * { margin: 0; padding: 0; box-sizing: border-box; }
      
      /* Basic styles */
      body { font-family: Arial, sans-serif; padding: 20px; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .text-left { text-align: left; }
      .mb-4 { margin-bottom: 1rem; }
      .mt-4 { margin-top: 1rem; }
      .mt-2 { margin-top: 0.5rem; }
      .pt-2 { padding-top: 0.5rem; }
      .border-t { border-top: 1px solid #000; }
      .border-b { border-bottom: 1px solid #000; }
      .font-bold { font-weight: bold; }
      table { width: 100%; border-collapse: collapse; }
      th, td { padding: 0.25rem; }
      
      @media print {
        body { margin: 0; padding: 0; }
        @page { size: 80mm 297mm; margin: 0; }
      }
    </style>
  `);

  printWindow.document.write('</head><body>');

  // Create container for React
  printWindow.document.write('<div id="print-root"></div>');

  // Create root and render
  const root = createRoot(printWindow.document.getElementById('print-root'));
  root.render(
    <BillTemplate
      items={items}
      totals={totals}
      customerName={customerInfos?.name}
      customerPhone={customerInfos?.phone}
      customergstNo={customerInfos?.gstNo}
      discount={totals?.discount || 0}
      paymentMethod={paymentInfo?.method}
      ordernumber={paymentInfo?.orderNo}
    />
  );

  printWindow.document.write('</body></html>');
  printWindow.document.close();

  // Wait for content to load before printing
  printWindow.onload = function () {
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.onafterprint = function () {
        printWindow.close();
      };
    }, 500);
  };
};

// Function to share bill via WhatsApp
const shareBillViaWhatsApp = (phoneNumber, billDetails) => {
  // Format bill details for WhatsApp
  const message = `
Your bill from BuyByeQ Restaurant:
Bill No: ${billDetails.billNo}
Date: ${new Date().toLocaleDateString()}

Items:
${billDetails.items.map(item =>
    `${item.item_name} x${item.quantity} - ₹${safeNumberFormat(item.item_price * item.quantity)}`
  ).join('\n')}

Subtotal: ₹${safeNumberFormat(billDetails.totals.subtotal)}
CGST: ₹${safeNumberFormat(billDetails.totals.cgst)}
SGST: ₹${safeNumberFormat(billDetails.totals.sgst)}
${billDetails.totals.discount > 0 ? `Discount: ₹${safeNumberFormat(billDetails.totals.discountAmount)}\n` : ''}
Grand Total: ₹${safeNumberFormat(billDetails.totals.discountedTotal)}

Thank you for dining with us!
`;

  // Format phone number (remove any spaces or special characters)
  const formattedPhone = phoneNumber.replace(/\D/g, '');

  // Create WhatsApp URL
  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(message)}`;

  // Open WhatsApp in new window
  window.open(whatsappUrl, '_blank');
};

export { BillTemplate, printBill, shareBillViaWhatsApp };